var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.urun.kampanyalimi==1 && _vm.urun.satisfiyat < _vm.urun.kampanyasizsatisfiyat)?_c('div',[_c('div',{staticClass:"indirim-urun"},[_c('span',{staticClass:"indirim-oran"},[_vm._v("%")]),_vm._v(_vm._s(_vm.indirimli(_vm.urun))+" "),_c('span',{staticClass:"indirim-yazisi"},[_vm._v("İndİrİm")])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }